import React, { useEffect } from 'react';
import './Zoom.css';

const ZoomMeeting = () => {
  useEffect(() => {
    // Redirect to Zoom meeting
    window.location.href = "https://us05web.zoom.us/j/3169182161?pwd=dDQ4N2luajBORWdjK04zYTRvK2N0UT09";
  }, []);

  return (
    <div className="zoom-redirect-container">
      <div className="zoom-redirect-content">
        <h1>Redirecting to Zoom Meeting</h1>
        <p>You are being redirected to the BB Global Solutions Zoom meeting...</p>
        <p>If you are not redirected automatically, please click the button below:</p>
        <a 
          href="https://us05web.zoom.us/j/3169182161?pwd=dDQ4N2luajBORWdjK04zYTRvK2N0UT09" 
          className="zoom-button"
          target="_blank"
          rel="noopener noreferrer"
        >
          Join Zoom Meeting
        </a>
        <div className="zoom-meeting-info">
          <p><strong>Meeting ID:</strong> 316 918 2161</p>
          <p><strong>Passcode:</strong> D393ag</p>
        </div>
      </div>
    </div>
  );
};

export default ZoomMeeting; 